import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FileTextFilledSvg from "@ant-design/icons-svg/es/asn/FileTextFilled";
import AntdIcon from "../components/AntdIcon";
var FileTextFilled = function FileTextFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FileTextFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FileTextFilled.displayName = 'FileTextFilled';
}
export default /*#__PURE__*/React.forwardRef(FileTextFilled);